export default {
  weatherReport: {
    title: "Wetter",
    labels: {
      forecastUnavailable: "Vorhersage nicht verfügbar",
      unavailableDescription: "Die Wettervorhersage ist für dieses Spiel nicht verfügbar.",
      unavailableValue: "N/V",
    },
    empty: {
      title: "Keine Wetterberichte verfügbar",
    },
  },
};
